import React from 'react';
import { PropTypes } from 'prop-types';
import { get, isNil } from 'lodash';

import { DOGS_OR_OTHER_PETS, ADDITIONAL_ANIMAL_TEXT_FOR_MT_WHITNEY, isExitingMtWhitney } from 'ui-inyonwhitney/src/utils/inyoUtils';
import { PERMIT as permitProps } from 'ui-permit/src/props/permit';
import { MAX_STOCK_KEY_NAME } from 'ui-permit/src/constants';
import { readRuleValue } from 'ui-permit/src/utils/utils';

import { ANIMAL_DETAILS_PROP_PATH, IS_BRINGING_ANIMALS_PROP_PATH } from '../constants/propPaths';
import AnimalList from './AnimalList';
import PetsQuantity from './PetsQuantity';

const defaultDataBindingMap = {
  [ANIMAL_DETAILS_PROP_PATH]: 'animals',
  [IS_BRINGING_ANIMALS_PROP_PATH]: 'is_bringing_animals'
};

const defaultAttributes = {};

export default (issuanceShape, dataBindingsMap = defaultDataBindingMap, attributes = defaultAttributes) => {
  const propTypes = {
    animalsLabels: PropTypes.objectOf(PropTypes.any),
    permit: permitProps,
    reservation: issuanceShape,
    pActions: PropTypes.shape({
      updatePendingReservation: PropTypes.func.isRequired
    }).isRequired,
    hidePets: PropTypes.bool,
    hideStocks: PropTypes.bool,
    hideQuestion: PropTypes.bool,
    maxStock: PropTypes.number,
    dontLookupMaxStock: PropTypes.bool,
    maxPets: PropTypes.number,
  };

  class AnimalDetail extends React.Component {
    handlePetsChange = (animals) => {
      const { pActions, reservation } = this.props;
      pActions.updatePendingReservation(reservation.id, dataBindingsMap[ANIMAL_DETAILS_PROP_PATH], animals);
    }

    handleAnimalsChange = (newValue) => {
      const { pActions, reservation } = this.props;
      let animals = get(reservation, dataBindingsMap[ANIMAL_DETAILS_PROP_PATH], []);
      if (isNil(animals)) {
        animals = [];
      }
      // find pet in list
      const newAnimals = [...newValue];
      const pet = animals.filter((a) => a.type === DOGS_OR_OTHER_PETS);
      if (pet.length > 0) {
        const numPets = pet[0].amount;
        newAnimals.push({ type: DOGS_OR_OTHER_PETS, amount: numPets });
      }
      pActions.updatePendingReservation(reservation.id, dataBindingsMap[ANIMAL_DETAILS_PROP_PATH], newAnimals);
    }

    render() {
      const { reservation, permit, animalsLabels } = this.props;
      let animals = get(reservation, dataBindingsMap[ANIMAL_DETAILS_PROP_PATH], []);

      if (isNil(animals)) {
        animals = [];
      }

      if (!this.props.hideQuestion) {
        const isBringingAnimals = get(reservation, dataBindingsMap[IS_BRINGING_ANIMALS_PROP_PATH], false);
        if (!isBringingAnimals) {
          return null;
        }
      }

      // filter out pets in animals for animalList
      const updatedAnimals = animals.filter((a) => a.type !== DOGS_OR_OTHER_PETS);
      let maxNumAnimals = this.props.maxStock || Number(readRuleValue(MAX_STOCK_KEY_NAME, permit.rules, reservation.division_id));
      if(this.props.dontLookupMaxStock) {
        maxNumAnimals = this.props.maxStock || 0;
      }

      return (
        <div className="per-animals-form per-section-group">
          {!this.props.hidePets && (
            <>
              <PetsQuantity
                animals={animals}
                animalsLabels={animalsLabels}
                handlePetsChange={this.handlePetsChange}
                maxPets={this.props.maxPets}
              />
            </>
          )}
          {!this.props.hideStocks && (
            <>
              <AnimalList
                animals={updatedAnimals}
                handleAnimalsChange={this.handleAnimalsChange}
                permit={permit}
                maxQuota={maxNumAnimals}
                additionalInstructions={isExitingMtWhitney(reservation) ? ADDITIONAL_ANIMAL_TEXT_FOR_MT_WHITNEY : ''} />
            </>
          )}
        </div>
      );
    }
  }

  AnimalDetail.propTypes = propTypes;
  AnimalDetail.attributes = attributes;

  return AnimalDetail;
}
